<template>
  <div>
    <!-- PL Table Section Start -->
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive tableMain gutr">
          <b-table
            show-empty
            stacked="md"
            :items="getListData"
            responsive
            :fields="PLField"
            primary-key="allModuleId"
            :per-page="pagination.perPage"
            :current-page="pagination.currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="position-relative"
          >
            <template slot="allModuleId" slot-scope="row0">
              <span>{{
                row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
              }}</span>
              <br />
              <b-button
                @click="row0.toggleDetails"
                class="mr-2"
                size="sm"
                style="font-size: 0.675rem"
                variant="outline-info"
              >
                {{ row0.detailsShowing ? "Hide More" : "Show More" }}
                Details
              </b-button>
              <InvExpSummary
                v-if="row0.item.allModuleId"
                :PMC_title="'Inv Exp Summary Job No - ' + row0.item.JOBNO"
                :PMC_JOBID="row0.item.allModuleId"
                :PMC_JOBNO="row0.item.JOBNO"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_AgentType="''"
                :PMC_Client="row0.item.clientName"
                :PMC_Sline="''"
              />
              <ContainerSummary
                v-if="row0.item.allModuleId"
                :PMC_title="'Container Summary Job No - ' + row0.item.JOBNO"
                :PMC_JOBID="row0.item.allModuleId"
                :PMC_JOBNO="row0.item.JOBNO"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_AgentType="''"
                :PMC_Client="row0.item.clientName"
                :PMC_Sline="''"
              />
              <!-- <JobWisePaymentsDetails
                  v-if="row0.item.allModuleId"
                  :allModuleId="Number(row0.item.allModuleId)"
                  :JobNo="row0.item.JOBNO"
                  /> -->
            </template>
            <template slot="row-details" slot-scope="row4">
              <b-card style="background: whiteSmoke">
                <b-row>
                  <b-col md="3" class="mb-2" v-if="row4.item.transportType">
                    <span><b>Transport Type :</b> {{ row4.item.transportType }}</span>
                  </b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.SOBDate">
                    <span><b>SOB Date :</b> {{ row4.item.SOBDate }}<br /></span>
                  </b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.transportType">
                    <span
                      ><b>Container Info :</b> {{ row4.item.containerInfo }}<br
                    /></span>
                  </b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.RasiedFrom">
                    <span><b>Rasied From :</b> {{ row4.item.RasiedFrom }}<br /></span>
                  </b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.RaisedBy">
                    <span><b>Raised By :</b> {{ row4.item.RaisedBy }}<br /></span>
                  </b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.shipmentTypeStatus"
                    ><span
                      ><b>Shipment Type :</b> {{ row4.item.shipmentTypeStatus
                      }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.LockStatus"
                    ><span
                      ><b>Lock Status :</b>
                      <b-badge
                        :variant="row4.item.LockStatus == 'Locked' ? 'danger' : 'success'"
                        ><b>{{ row4.item.LockStatus }}</b></b-badge
                      ><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.BillStatus"
                    ><span
                      ><b>Bill Status :</b>
                      <b-badge
                        :variant="
                          row4.item.BillStatus == 'Billing Completed'
                            ? 'success'
                            : 'danger'
                        "
                        ><b>{{ row4.item.BillStatus }}</b></b-badge
                      ><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.totExpVal"
                    ><span
                      ><b>Exp Amt :</b>
                      <b
                        v-if="
                          row4.item.totExpVal != undefined && row4.item.totExpVal != null
                        "
                        >{{ row4.item.totExpVal.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.totExpGST"
                    ><span
                      ><b>Exp GST Amt :</b>
                      <b
                        v-if="
                          row4.item.totExpGST != undefined && row4.item.totExpGST != null
                        "
                        >{{ row4.item.totExpGST.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.totExpGSTVal"
                    ><span
                      ><b>Exp Tot Amt :</b>
                      <b
                        v-if="
                          row4.item.totExpGSTVal != undefined &&
                          row4.item.totExpGSTVal != null
                        "
                        >{{ row4.item.totExpGSTVal.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>

                  <b-col md="3" class="mb-2" v-if="row4.item.totInvVal"
                    ><span
                      ><b>Inv Amt :</b>
                      <b
                        v-if="
                          row4.item.totInvVal != undefined && row4.item.totInvVal != null
                        "
                        >{{ row4.item.totInvVal.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.totInvGST"
                    ><span
                      ><b>Inv GST Amt :</b>
                      <b
                        v-if="
                          row4.item.totInvGST != undefined && row4.item.totInvGST != null
                        "
                        >{{ row4.item.totInvGST.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.totInvGSTVal"
                    ><span
                      ><b>Inv Tot Amt :</b>
                      <b
                        v-if="
                          row4.item.totInvGSTVal != undefined &&
                          row4.item.totInvGSTVal != null
                        "
                        >{{ row4.item.totInvGSTVal.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.totPLVal"
                    ><span
                      ><b>PL Amt :</b>
                      <b
                        v-if="
                          row4.item.totPLVal != undefined && row4.item.totPLVal != null
                        "
                        >{{ row4.item.totPLVal.toFixed(2) }}</b
                      ><b v-else>0</b><br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.PICK"
                    ><span><b>Pick :</b> {{ row4.item.PICK }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.STUF">
                    <span><b>Stuff :</b> {{ row4.item.STUF }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.HOV"
                    ><span><b>HOV :</b> {{ row4.item.HOV }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.POR"
                    ><span><b>POR :</b> {{ row4.item.POR }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.POL"
                    ><span><b>POL :</b> {{ row4.item.POL }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.POD"
                    ><span><b>POD :</b> {{ row4.item.POD }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.FPOD"
                    ><span><b>FPOD :</b> {{ row4.item.FPOD }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.MBLNO"
                    ><span><b>MBLNO :</b> {{ row4.item.MBLNO }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.HBLNO"
                    ><span><b>HBLNO :</b> {{ row4.item.HBLNO }}<br /></span
                  ></b-col>
                  <b-col md="3" class="mb-2" v-if="row4.item.vessel_voyage"
                    ><span><b>Vessel :</b> {{ row4.item.vessel_voyage }}</span></b-col
                  >
                  <b-col md="12">
                    <Profit-Loss
                      v-if="row4.item.allModuleId"
                      :PMS_fk_all_module_id="row4.item.allModuleId"
                      :PMS_jb_series="row4.item.JOBNO"
                      :PMS_fk_client_id="row4.item.clientName"
                      :PLAccordianStatus="true"
                      :PLAccordianButton="false"
                    />
                  </b-col>
                </b-row>
              </b-card>
            </template>
            <template slot="JOBNO" slot-scope="row1">
              <span>JOB Type : {{ row1.item.JOBType }}<br /></span>
              <span>JOB NO : {{ row1.item.JOBNO }}<br /></span>
              <span>JOB Date : {{ row1.item.JOBDate }}<br /></span>
            </template>
            <template slot="BillStatus" slot-scope="row2">
              <span
                >PL Status :
                <b-badge
                  :variant="
                    row2.item.totPLLabel == 'Loss'
                      ? 'danger'
                      : row2.item.totPLLabel == 'Profit'
                      ? 'success'
                      : 'info'
                  "
                  ><b>{{ row2.item.totPLLabel }}</b></b-badge
                ><br
              /></span>
          
            </template>
            <template slot="totExpVal" slot-scope="row3">
              <span>PL Amt : {{ row3.item.totPLVal }}<br /></span>
              <span
                >PL % :
                <b
                  v-if="
                    row3.item.totPLPercentage != undefined &&
                    row3.item.totPLPercentage != null
                  "
                  >{{ row3.item.totPLPercentage.toFixed(2) }}</b
                ><b v-else>0</b><br
              /></span>
      
            </template>
            <template slot="notExistInvoice" slot-scope="row5">
              <span v-if="row5.item.notExistInvoice"
                >Not Recd From Tally Inv : {{ row5.item.notExistInvoice }}<br
              /></span>
              <span v-if="row5.item.notExistOSDR"
                >Not Recd From Tally OSDR : {{ row5.item.notExistOSDR }}<br
              /></span>
              <span v-if="row5.item.notExistOSCR"
                >Not Recd From Tally OSCR : {{ row5.item.notExistOSCR }}<br
              /></span>
            </template>
            <template slot="clientName" slot-scope="row4">
              <span>Client : {{ row4.item.clientName }}<br /></span>
              <span>Sline : {{ row4.item.shippingLine }}<br /></span>
              <span
                      ><b>Bill Status :</b>
                      <b-badge
                        :variant="
                          row4.item.BillStatus == 'Billing Completed'
                            ? 'success'
                            : 'danger'
                        "
                        ><b>{{ row4.item.BillStatus }}</b></b-badge
                      ><br /></span
                  >
              <span
                    v-if="
                      row4.item.finalBillingCompleted == '1' &&
                      row4.item.assignmentCloseReason
                    "
                    style="color: green"
                    v-html="row4.item.assignmentCloseReason"
                    >{{ wordWrap(row4.item.assignmentCloseReason, 24) }}</span
                  >
              <!-- <span>Sline : {{ row4.item.assignmentCloseReason }}<br /></span> -->
              <PlApprovalCom
                v-if="row4.item.allModuleId"
                :PL_title="'Profit Loss Approval - '"
                :PL_JOBID="row4.item.allModuleId"
                :PL_JOBNO="row4.item.JOBNO"
                :PL_JOBDATE="row4.item.JOBDate"
                :PL_JOBTYPE="row4.item.JOBType"
                :PL_Client="row4.item.clientName"
                :PL_Sline="row4.item.shippingLine"
                :PL_pl_approved_flag="row4.item.pl_approved"
                :PL_is_pl_approved="row4.item.is_pl_approved"
                :PL_pl_approved_date="row4.item.pl_approved_date"
                :PL_pl_approved_remark="row4.item.pl_approved_remark"
              />
            </template>
          </b-table>
        </div>
        <div>
          <b-pagination
            limit="8"
            align="center"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total-rows="totalRowsCount"
            @change="onPageChange($event)"
          ></b-pagination>
        </div>
      </div>
    </div>
    <!-- PL Table Section End -->
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat,wordWrap } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
// import ProfitLoss from "../common/profitLoss.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
// import DocForm from "../allModuleForm/docLibrary.vue";
// import AddMessage from "../allModuleForm/addMessage.vue";
// import AssignmentSummary from "../common/assignmentSummary.vue";
// import SplitmergeSummary from "../common/splitmergeSummary.vue";
// import MultiUpdate from "../common/multiUpdate.vue";
// import CommonLock from "../common/commonLock.vue";
import PlApprovalCom from "../common/plApprovalCom.vue";

export default {
  props: ["tableData", "PLFields", "totalRowsCount"],
  beforeMount() {},
  mounted() {},

  data() {
    return {
      PLList: this.tableData.length > 0 ? this.tableData : [],
      PLField: this.PLFields,
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      docURL: URL_BASE_DOC,
    };
  },
  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},


  components: {
    Loading,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
    FilterAgencyModal,
    InvExpSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    PlApprovalCom,
  },

  computed: {
    getListData() {
      this.PLList = this.tableData.length > 0 ? this.tableData : [];
      return this.PLList;
    },
  },
  watch: {
    tableData: {
      handler: function (newTableData, oldTableData) {
        // Update PLList when tableData changes
        this.PLList = newTableData.length > 0 ? newTableData : [];
      },
      deep: true,
    },
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  created() {
    eventBus.$on("plApprovalComp", (plApprovalComp) => {
      if (plApprovalComp.Success == 1) {
        this.PLList.map((item) => {
          if (item.allModuleId == plApprovalComp.allModuleId) {
            item.pl_approved = plApprovalComp.pl_approved;
            item.is_pl_approved = plApprovalComp.is_pl_approved;
            item.pl_approved_date = plApprovalComp.pl_approved_date;
            item.pl_approved_remark = plApprovalComp.pl_approved_remark;
          }
        });
        this.updateListData();
        this.$forceUpdate();
      }
    });
  },
  methods: {
    wordWrap,
    updateListData() {
      this.PLList = this.tableData.length > 0 ? this.tableData : [];
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.JOBNO;
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    gotoDocs(item) {
      this.$router.push({
        path: "/allModule/docs/" + item,
      });
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }

      this.getProfitLossData("Normal", "0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getProfitLossData("Normal", "0", "0", "1", "1");
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// plTable.vue?3ea3094a